// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Order_item_requests_UploadPhotoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/order_item_requests/upload_photo
 *
 * Validates input for uploading a photo before order item creation.
 * Multipart form: photo (file).
 * No order_item_id required — photo is stored and URL returned for later attachment.
 */
import { registerContract } from './validate'

export interface Order_item_requests_UploadPhotoInput {
_files: unknown[]
}

registerContract('Order_item_requests_UploadPhotoInput', {
  _files: { type: 'array',   required: true },
})
